import React from "react";
import { TagContainer, TagText, TagIcon } from "./BaseStyles";

export type BaseTagProps = {
  children: string;
  maxWidth?: number | string;
};

export type TagProps = BaseTagProps & {
  hideTagIcon?: boolean;
  icon?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

export const Tag: React.FC<TagProps> = ({ children, maxWidth, onClick, hideTagIcon, icon }) => {
  if (process.env.NODE_ENV !== "production" && children.length === 0) {
    /* eslint-disable-next-line no-console */
    console.warn("Tags must contain at least 1 character.");
  }

  return (
    <TagContainer onClick={onClick} style={{ maxWidth }} $hideTagIcon={hideTagIcon}>
      {!hideTagIcon && <TagIcon icon={icon} />}
      <TagText>{children}</TagText>
    </TagContainer>
  );
};
